import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, TextCharLimit, Button, SwitchCheckbox} from 'views/components';
import {translate, Translate} from 'views/module';

const Content = (props) => {
  const [questionTitle, setQuestionTitle] = React.useState('');
  const [isRequired, setIsRequired] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);

  const careviewItem = props.careviewItem;
  const setViewMode = props.setViewMode;
  const updateQuestion = props.updateQuestion;

  React.useEffect(() => {
    setQuestionTitle(careviewItem.questionData.questionTitle);
    setIsRequired(careviewItem.questionData.isRequired);
  }, [careviewItem]);

  // Update the save button's disabled state
  React.useEffect(() => {
    setIsSaveDisabled(!questionTitle.trim().length);
  }, [questionTitle]);

  const onSave = () => {
    setIsSaving(true);
    const updatedCareviewItem = {
      ...careviewItem.questionData,
      questionTitle: questionTitle,
      isRequired,
    };
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateQuestion(updatedCareviewItem, onSuccess);
  };

  return (
    <Box>
      <TextCharLimit
        label={translate('client.ClientDetail.CareviewSettings.Types.FreeFormText.Question')}
        placeholder={translate('client.ClientDetail.CareviewSettings.Types.FreeFormText.Question')}
        value={questionTitle}
        onChange={setQuestionTitle}
        charLimit={180}
        autoFocus
        fullWidth
      />
      <SwitchCheckbox
        label={translate('client.ClientDetail.CareviewSettings.Types.FreeFormText.FieldIsRequired')}
        value={isRequired}
        onChange={setIsRequired}
      />
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='client.ClientDetail.CareviewSettings.Types.Actions.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          <Translate expression='client.ClientDetail.CareviewSettings.Types.Actions.Save' />
        </Button>
      </Stack>
    </Box>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  updateQuestion: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
